import { mergeClasses, Tooltip } from "@fluentui/react-components";
import InfoOutlineIcon from "~icons/material-symbols/info-outline";
import { memo, ReactNode } from "react";
import { useSearchModeLabelStyles } from "../styles/SearchModeLabel.styles";

type SearchModeLabelProps = {
  label: string;
  tooltipContent: ReactNode;
  searchMode: string;
  selectedMode: string;
  disabledRadioLabel: boolean;
};

export const SearchModeLabel = memo(
  ({ label, tooltipContent, searchMode, selectedMode, disabledRadioLabel }: SearchModeLabelProps) => {
    const styles = useSearchModeLabelStyles();

    return (
      <div
        className={mergeClasses(
          selectedMode === searchMode ? styles.activeSearchMode : "",
          styles.searchModeLabel,
          disabledRadioLabel ? styles.disabledRadioLabel : ""
        )}
      >
        <span>{label}</span>
        <Tooltip
          content={{
            children: tooltipContent,
            className: styles.spanWidth,
          }}
          positioning={"below-start"}
          relationship={"description"}
          withArrow
        >
          <InfoOutlineIcon className="text-[18px]" />
        </Tooltip>
      </div>
    );
  }
);
